export default __webpack_public_path__ + "static/media/ElectromagneticSpectrumImg.2c55f54a.jpg";